import { WorkOrder } from '@order-management/types';
import { useCallback } from 'react';
import { Element, Icon } from 'react-bulma-components';
import { FaArrowRight } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import Button from '../../ui/button/button';
import Modal from '../../ui/modal/modal';

export interface WorkOrderCreatedConfirmationModalProps {
  show: boolean;
  workOrder?: WorkOrder;
}

export function WorkOrderCreatedConfirmationModal({
  show,
  workOrder,
}: WorkOrderCreatedConfirmationModalProps) {
  const navigate = useNavigate();

  const navigateToDrafts = useCallback(() => {
    navigate('/work-orders/dashboard/drafts');
  }, [navigate]);

  const navigateToCreateNewOrder = useCallback(() => {
    navigate('/work-orders/create/sales-orders');
  }, [navigate]);

  const navigateToSetUp = useCallback(() => {
    navigate(`/work-orders/${workOrder?.id}/device-groups`);
  }, [navigate, workOrder]);

  return (
    <Modal show={show} title="Work order created" titleClassName="mb-4">
      <p>
        You have successfully created work order{' '}
        <span className="has-text-weight-bold">
          #{workOrder?.number} - {workOrder?.name}
        </span>
      </p>
      <Element
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mt={8}
      >
        <div>
          <Button color="primary-dark" outlined onClick={navigateToDrafts}>
            Back to drafts
          </Button>
          <Button
            color="primary-dark"
            outlined
            ml={3}
            onClick={navigateToCreateNewOrder}
          >
            Create a new work order
          </Button>
        </div>
        <Button color="primary-dark" onClick={navigateToSetUp}>
          <span>Set up</span>
          <Icon>
            <FaArrowRight />
          </Icon>
        </Button>
      </Element>
    </Modal>
  );
}

export default WorkOrderCreatedConfirmationModal;
